import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { NomWebServicesJson } from '@common/services/nom-web-services-json';
import { ModalService } from '@common/components/modal/modal.service';
import { map } from 'rxjs/operators';
import { Util } from '@suite/common/utils/util';

declare var serverConfig: { [id: string]: any };
declare var debugMode: string;

@Injectable({ providedIn: 'root' })
export class JwtIncerceptor implements HttpInterceptor {

    constructor(
        private nomWebServicesJson: NomWebServicesJson,
        private modalService: ModalService
    ) { }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(this.addAuthHeader(request)).pipe(map((r) => {
            if (r instanceof HttpResponse) {
                this.handleResponse(r);
            }
            return r;
        }));
    }

    private addAuthHeader(request: HttpRequest<unknown>): HttpRequest<unknown> {
        const url = request.url;
		const method = request.method
        if (!url.endsWith("/api/IsAlive") && method != 'JSONP') {
            let jwtToken = this.nomWebServicesJson.token;
            const isDiscoverReq = url.includes('enpscloud.com') || url.includes('usviking.com'); 
            if (jwtToken && !isDiscoverReq) {
                return request.clone({
                    setHeaders: {
                        Authorization: jwtToken
                    }
                })
            }
        }
        return request;
    }

    private handleResponse(r: HttpResponse<any>) {
        const isDiscoverReq = r.url.includes('enpscloud.com') || r.url.includes('usviking.com'); 
        if (!isDiscoverReq) {
            const jwtToken = r.headers.get('Authorization');
            if (jwtToken) this.nomWebServicesJson.token = jwtToken;
        }
        const newNomTokenId = r.headers.get("X-ENPS-TOKEN");
        if (newNomTokenId && (newNomTokenId != this.nomWebServicesJson.NomTokenId)) {
            this.nomWebServicesJson.NomTokenId = newNomTokenId;
            localStorage.setItem("SessionNomTokenId", this.nomWebServicesJson.NomTokenId);
        }
        if (
            (r.status >= 200) &&
            (r.status < 300) &&
            !(
                r.url.endsWith("/api/IsAlive") ||
                r.url.endsWith("/api/SSOSettings") ||
                r.url.endsWith("/api/SSOConfigSetings")
            )
        ) {
            this.nomWebServicesJson.noSession = false;
        }
        const version = r.headers.get('jsonversion')
        if (version && (version != serverConfig["pstVersion"]) && (debugMode!= 'true')) {
			//TODO: UNCOMMENT AFTER MODAL REWORK
            // const ref = this.modalService.openAlert('New Version', "A newer version is now available. Please click 'OK' to upgrade. You will need to login again.", '')
            // ref.result.then(() => {
            //     Util.clearLocalStorage();
            //     window.location.reload();
            // })
        }
    }
}